import { saveResource, fetchResources, fetchResourceById } from '@/connectors/ras';

const initialState = () => ({
  resources: [],
  filters: { limit: 48, offset: 0 },
});

const getters = {
  currentModel: (state) => state.model,
  models: (state) => state.resources,
  modelFilters: (state) => state.filters,
};

const mutations = {
  setModels(state, model) {
    Object.assign(state, { resources: model });
  },
  setModelFilters(state, filters) {
    Object.assign(state, { filters: { ...state.filters, ...filters } });
  },
  setCurrentModel(state, data) {
    Object.assign(state, { model: data });
  },
};

const actions = {
  async createModel({ rootState }, modelData) {
    return saveResource(modelData, { request: rootState.users.user.session.request, resourceType: 'mesh' });
  },
  async fetchModelById({ rootState, commit }, id) {
    const response = await fetchResourceById(
      { id },
      { request: rootState.users.user.session.request, resourceType: 'mesh' },
    );
    commit('setCurrentModel', response.data);
  },
  async fetchModels({ state, rootState, commit }) {
    const response = await fetchResources(state.filters, {
      request: rootState.users.user.session.request,
      resourceType: 'mesh',
    });
    commit('setModels', response.data.objects);
    commit('setModelFilters', response.data.meta);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
